/* Native Shopify newsletter handoff. Identity is issued only after Admin proof.
 * Never stores the email or changes the native form action, CAPTCHA or consent.
 */
(function () {
  'use strict';
  if (window.__havjoyBrowseSignupLoaded) return;
  window.__havjoyBrowseSignupLoaded = true;
  var ENDPOINT = 'https://ordernotfound.com/events/browse-signup';
  var STORAGE = 'hj_browse_signup';
  var forms = new WeakMap(), polling = false, timer = null, generation = 0;
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!p && p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true;
    } catch (_) { return false; }
  }
  function clear() {
    generation++;
    if (timer) clearTimeout(timer);
    timer = null;
    try { sessionStorage.removeItem(STORAGE); } catch (_) {}
  }
  function saved() {
    try {
      var value = JSON.parse(sessionStorage.getItem(STORAGE));
      if (value === null) return null;
      if (value && typeof value.ticket === 'string' && /^sc1\.[A-Za-z0-9_.-]{16,500}$/.test(value.ticket) &&
          Number.isFinite(value.expiresAt) && value.expiresAt > Date.now() && value.expiresAt <= Date.now() + 600000 &&
          (value.attempts || 0) < 30) return value;
    } catch (_) {}
    clear();
    return null;
  }
  function persist(value) {
    try { sessionStorage.setItem(STORAGE, JSON.stringify(value)); return true; } catch (_) { return false; }
  }
  function request(body, timeout) {
    var controller = new AbortController();
    var deadline = setTimeout(function () { controller.abort(); }, timeout);
    body.consent = {analytics:true, marketing:true};
    return fetch(ENDPOINT, {method:'POST', credentials:'omit', signal:controller.signal,
      headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)})
      .then(function (response) { if (!response.ok) throw new Error('Verification unavailable'); return response.json(); })
      .finally(function () { clearTimeout(deadline); });
  }
  function poll() {
    if (polling || !allowed()) return;
    var pending = saved();
    if (!pending) return;
    if ((pending.nextAt || 0) > Date.now()) {
      timer = setTimeout(poll, pending.nextAt - Date.now());
      return;
    }
    polling = true;
    var version = generation;
    pending.attempts = (pending.attempts || 0) + 1;
    pending.nextAt = Date.now() + 5500;
    persist(pending);
    request({action:'claim', ticket:pending.ticket}, 10000).then(function (result) {
      if (!allowed() || version !== generation) return;
      if (result.status === 'identified' && typeof result.token === 'string' && /^s1\.[A-Za-z0-9_.-]{16,500}$/.test(result.token) &&
          Number.isFinite(result.expiresAt) && result.expiresAt > Date.now()) {
        clear();
        document.dispatchEvent(new CustomEvent('havjoy:browse-identity', {detail:{token:result.token, expiresAt:result.expiresAt}}));
      } else if (result.status === 'expired') clear();
    }).catch(function () { /* Native signup is independent from verification availability. */ })
      .finally(function () {
        polling = false;
        if (version === generation && allowed()) timer = setTimeout(poll, 5500);
      });
  }
  function newsletter(form) {
    if (!form || form.tagName !== 'FORM' || typeof form.requestSubmit !== 'function') return null;
    var target;
    try { target = new URL(form.action, location.href); } catch (_) { return null; }
    if (form.method.toUpperCase() !== 'POST' || target.origin !== location.origin || !/^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/contact\/?$/.test(target.pathname)) return null;
    var type = form.elements.namedItem('form_type'), email = form.elements.namedItem('contact[email]'), tags = form.elements.namedItem('contact[tags]');
    if (!type || type.value !== 'customer' || !email || email.type !== 'email' || !tags ||
        tags.value.split(',').map(function (v) { return v.trim(); }).indexOf('newsletter') < 0) return null;
    return {email:email, tags:tags};
  }
  document.addEventListener('submit', function (event) {
    var form = event.target, fields = newsletter(form);
    if (!fields || event.defaultPrevented) return;
    var state = forms.get(form);
    if (state && state.once) { state.once = false; return; }
    if (state && state.resume && state.version === generation && state.email === fields.email.value.trim().toLowerCase() && state.until > Date.now()) return;
    if (!allowed() || !form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (state && state.busy) return;
    state = {busy:true, resume:false};
    forms.set(form, state);
    clear();
    document.dispatchEvent(new Event('havjoy:browse-forget'));
    var version = generation; state.version = version;
    var email = fields.email.value.trim().toLowerCase(), submitter = event.submitter;
    request({action:'begin', email:email}, 2500).then(function (result) {
      if (!allowed() || version !== generation || fields.email.value.trim().toLowerCase() !== email ||
          !/^hj_browse_[a-f0-9]{40}$/.test(result.tag || '') ||
          !/^sc1\.[A-Za-z0-9_.-]{16,500}$/.test(result.ticket || '') ||
          !Number.isFinite(result.expiresAt) || result.expiresAt <= Date.now()) return;
      var pending = {ticket:result.ticket, expiresAt:Math.min(result.expiresAt, Date.now()+600000), attempts:0};
      if (!persist(pending)) return;
      var tags = fields.tags.value.split(',').filter(function (tag) { return !/^hj_browse_[a-f0-9]{40}$/.test(tag.trim()); });
      fields.tags.value = tags.join(',') + ', ' + result.tag;
    }).catch(function () { /* Always release the original native form on failure. */ })
      .finally(function () {
        state.busy = false; state.resume = true; state.once = true;
        state.email = fields.email.value.trim().toLowerCase(); state.until = Date.now()+600000;
        // Re-enter native submission so Shopify CAPTCHA and normal submit handlers run.
        if (submitter && submitter.form === form && !submitter.disabled) form.requestSubmit(submitter);
        else form.requestSubmit();
      });
  }, true);
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) clear(); else poll();
  });
  document.addEventListener('havjoy:browse-consent-ready', poll);
  document.addEventListener('DOMContentLoaded', poll, {once:true});
  window.addEventListener('load', poll, {once:true});
  window.addEventListener('pageshow', poll);
  window.addEventListener('pagehide', function () { if (timer) clearTimeout(timer); });
  if (document.readyState !== 'loading') poll();
  // Meta Email sign-up offers bypass the native newsletter form.
  // Read only the Shopify coupon cookie, after consent; proof stays server-side.
  var metaBusy = false, metaAttempts = 0, metaTimer = null;
  function metaCode() {
    try {
      var values = document.cookie.split(';').map(function (item) { return item.trim(); })
        .filter(function (item) { return item.indexOf('discount_code=') === 0; });
      if (values.length !== 1) return '';
      var code = decodeURIComponent(values[0].slice('discount_code='.length)).toUpperCase();
      return /^(FB|IG)-EMAIL-[A-Z0-9]{8}$/.test(code) ? code : '';
    } catch (_) { return ''; }
  }
  function occupied() {
    try {
      var identity = JSON.parse(localStorage.getItem('hj_browse'));
      if (identity && typeof identity.token === 'string' && /^(b1|s1)\./.test(identity.token) &&
          Number.isFinite(identity.expiresAt) && identity.expiresAt > Date.now()) return true;
      var nativeSignup = JSON.parse(sessionStorage.getItem(STORAGE));
      return !!nativeSignup && Number.isFinite(nativeSignup.expiresAt) && nativeSignup.expiresAt > Date.now();
    } catch (_) { return true; }
  }
  function metaOffer() {
    if (metaBusy || metaAttempts >= 3 || !allowed() || occupied()) return;
    var code = metaCode();
    if (!code) return;
    metaBusy = true; metaAttempts++;
    var version = generation;
    request({action:'meta_offer', code:code}, 10000).then(function (result) {
      if (!allowed() || version !== generation || occupied() || metaCode() !== code) return;
      if (result.status === 'identified' && typeof result.token === 'string' &&
          /^s1\.[A-Za-z0-9_.-]{16,500}$/.test(result.token) &&
          Number.isFinite(result.expiresAt) && result.expiresAt > Date.now() &&
          result.expiresAt <= Date.now() + 30*24*60*60*1000) {
        document.dispatchEvent(new CustomEvent('havjoy:browse-identity',
          {detail:{token:result.token, expiresAt:result.expiresAt}}));
      }
    }).catch(function () { /* A coupon never identifies anyone without Admin proof. */ })
      .finally(function () {
        metaBusy = false;
        if (allowed() && !occupied() && metaAttempts < 3)
          metaTimer = setTimeout(metaOffer, 31000);
      });
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) { if (metaTimer) clearTimeout(metaTimer); metaTimer = null; }
    else metaOffer();
  });
  document.addEventListener('havjoy:browse-consent-ready', metaOffer);
  document.addEventListener('DOMContentLoaded', metaOffer, {once:true});
  window.addEventListener('load', metaOffer, {once:true});
  window.addEventListener('pageshow', metaOffer);
  window.addEventListener('pagehide', function () { if (metaTimer) clearTimeout(metaTimer); });
  if (document.readyState !== 'loading') metaOffer();

})();
